<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="page-title">{{ $t('dmsb.text1') }}</div>
    <!--        pad-->
    <div class="main-box1">
      <div class="main">
        <div class="box-pad">
          <div class="box-pad-top">
            <div>
              <img :src="padUrls[padindex]" class="img-big">
              <div class="img-list">
                <img v-for="(item,index) in padUrls" :key="index" :src="item" class="img-small" @click="padindex=index">
              </div>
            </div>
            <div class="top-right">
              <div class="box-name">{{ $t('dmsb.text2') }}</div>
              <div class="box-text">
                {{ $t('dmsb.text3') }}
              </div>
              <div style="height: 50px"></div>
              <div v-for="(item,index) in  $t('dmsb.padList')" :key="index" class="right-item">
                <div
                  style="background: #1F65FE;width: 6px;height: 6px;border-radius: 3px;opacity: 0.2;margin-right: 20px;margin-top: 5px"></div>
                <div style="font-weight: 600">
                  {{ item.name }}
                  <div class="right-item-text"> {{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pad-params">
            {{ $t('dmsb.text4') }}
            <div class="params-grid">
              <div v-for="(item,index) in $t('dmsb.padParams')" :key="index" class="grid-item">
                {{ item.name }}
                <div class="item-text">
                  <div
                    style="width: 2px;height: 22px;background: #151515;opacity: 0.4;margin-right: 18px;margin-top: 3px"></div>
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    pc-->
    <div class="main-box1" style=" background-image: url('/static/images/v2/dmsb/dmsb_bg2.png');">
      <div class="main">
        <div class="box-pad">
          <div class="box-pad-top">
            <div>
              <img :src="pcUrls[pcindex]" class="img-big">
              <div class="img-list">
                <img v-for="(item,index) in pcUrls" :key="index" :src="item" class="img-small" @click="pcindex=index">
              </div>
            </div>
            <div class="top-right">
              <div class="box-name">{{ $t('dmsb.text5') }}</div>
              <div class="box-text">
                {{ $t('dmsb.text6') }}
              </div>
              <div style="height: 50px"></div>
              <div v-for="(item,index) in $t('dmsb.pcList')" :key="index" class="right-item">
                <div
                  style="background: #1F65FE;width: 6px;height: 6px;border-radius: 3px;opacity: 0.2;margin-right: 20px;margin-top: 5px"></div>
                <div style="font-weight: 600">
                  {{ item.name }}
                  <div class="right-item-text"> {{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pad-params">
            {{ $t('dmsb.text7') }}
            <div class="params-grid">
              <div v-for="(item,index) in $t('dmsb.pcParams')" :key="index" class="grid-item">
                {{ item.name }}
                <div class="item-text">
                  <div
                    style="width: 2px;height: 22px;background: #151515;opacity: 0.4;margin-right: 18px;margin-top: 3px"></div>
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box1" style="background: #E8E8E8">
      <div class="main">
        <div class="box-pad">
          <div class="box-mesh-name">{{ $t('dmsb.text8') }}</div>
          <div class="box-mesh-text">
            {{ $t('dmsb.text9') }}
          </div>
          <div class="box-mesh-name">{{ $t('dmsb.text10') }}</div>
          <div class="box-mesh-text">{{ $t('dmsb.text11') }}
          </div>
          <div v-for="(item,index) in $t('dmsb.meshList')" :key="index" class="box-pad-top" style="border: 0">
            <div>
              <img :src="item.urls[item.position]" class="img-big" style="object-fit: contain">
              <div class="img-list">
                <img v-for="(i,k) in item.urls" :key="k" :src="i" class="img-small" style="width: 80px" @click="item.position=k">
              </div>
            </div>
            <div class="top-right">
              <div class="box-name">{{item.title}}</div>
              <div class="box-name2">{{item.name}}</div>
              <div class="box-text" style="height: 218px;padding-top: 20px;box-sizing: border-box;white-space: pre;">
                {{item.text}}
              </div>
              <div style="height: 50px"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {
      padindex: 0,
      padUrls: ['/static/images/v2/dmsb/PAD.png', '/static/images/v2/dmsb/PAD2.png', '/static/images/v2/dmsb/PAD3.png', '/static/images/v2/dmsb/PAD4.png'],
      pcindex: 0,
      pcUrls: ['/static/images/v2/dmsb/PC1.png', '/static/images/v2/dmsb/PC2.png', '/static/images/v2/dmsb/PC3.png', '/static/images/v2/dmsb/PC4.png'],

    };
  },
  watch: {
    $route(to, from) {
      if (to.name === 'dmsb2') {
        window.scrollTo(0, 1256);
      } else if (to.name === 'dmsb3') {
        window.scrollTo(0, 2519);
      } else if (to.name === 'dmsb4') {
        window.scrollTo(0, 2819);
      }
    },
  },
  created() {

  },
  mounted() {
    let name=this.$route.name;
    if (name==='dmsb2'){
      console.log('dadwaaw',this.$route);
      window.scrollTo(0, 1256);
    }else if (name==='dmsb3'){
      window.scrollTo(0, 2519);
    }else if (name==='dmsb4') {
      window.scrollTo(0, 2819);
    }
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.template-container {
  position: relative;
  width: 100%;
  .page-title{
    z-index: 100;
    top: 22px;
    font-size: 14px;
    font-weight: 600;
    color: #3D3D3D;
    width: 1280px;
    margin-left: calc((100% - 1280px)/2);
    position: absolute;
  }
  .main {
    width: 1280px;
  }

  .main-box1 {
    width: 100%;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/dmsb/dmsb_bg1.png");
  }

  .box-pad {
    margin: 60px 0;
    border-radius: 10px;
    padding: 80px 40px;
    width: 100%;
    background: #EEEEEE;

    .img-big {
      object-fit: cover;
      width: 710px;
      height: 455px;
      border-radius: 10px;
      background: #D8D8D8;
    }

    .box-pad-top {
      border-bottom: 1px solid #C2C2C2;
      display: flex;


      .img-list {
        display: flex;
      }

      .img-small {
        object-fit: contain;
        cursor: pointer;
        width: 150px;
        height: 150px;
      }

      .top-right {
        margin-right: 80px;
        margin-left: 32px;
      }

      .box-name {
        font-size: 36px;
        font-weight: 600;
        color: #1F65FE;
      }

      .box-name2 {
        margin-top: 19px;
        font-size: 20px;
        font-weight: 600;
        color: #1F65FE;
      }

      .box-text {
        margin-left: 32px;
        padding-left: 23px;
        border-left: 3px solid #D6D6D6;;
        margin-top: 32px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #383838;
      }

      .right-item {
        display: flex;
        color: #1F65FE;
        font-weight: 600;
        font-size: 16px;
        margin-left: 32px;
        margin-bottom: 25px;

        .right-item-text {
          margin-top: 13px;
          font-size: 12px;
          color: #767676;
        }
      }
    }

    .pad-params {
      margin-top: 28px;
      font-size: 20px;
      font-weight: 600;
      color: #151515;

      .params-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        column-gap: 10px;
        row-gap: 10px;
        color: #151515;

        .grid-item {
          margin-top: 59px;
          font-size: 24px;
          font-weight: 600;

          .item-text {
            margin-top: 24px;
            display: flex;
            font-size: 16px;
            line-height: 32px;

          }
        }
      }
    }

    .box-mesh-name {
      margin-bottom: 32px;
      font-size: 36px;
      font-weight: 600;
      color: #1F65FE;
    }

    .box-mesh-text {
      border-left: 3px solid #D6D6D6;
      padding-left: 23px;
      margin-left: 31px;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: #383838;
      margin-bottom: 129px;
    }

    .mesh-item {
      display: flex;
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .page-title{
      display: none;
      z-index: 100;
      top: 22px;
      font-size: 14px;
      font-weight: 600;
      color: #3D3D3D;
      width: 100%;
      position: absolute;
    }
    .main {
      width: 100%;
    }

    .main-box1 {
      width: 100%;
      display: flex;
      justify-content: center;
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/dmsb/dmsb_bg1.png");
    }

    .box-pad {
      margin: 20px 0;
      border-radius: 10px;
      padding: 20px 20px;
      width: 90%;
      background: #EEEEEE;

      .img-big {
        object-fit: contain;
        width: 100%;
        height: 300px;
        border-radius: 10px;
        background: #D8D8D8;
      }

      .box-pad-top {
        border-bottom: 1px solid #C2C2C2;
        display: flex;
        flex-direction: column;
        .img-list {
          display: flex;
        }

        .img-small {
          object-fit: contain;
          cursor: pointer;
          flex: 1;
          width: 10px;
          height: 100px ;
        }

        .top-right {
          margin-right: 20px;
          margin-left: 22px;
        }

        .box-name {
          margin-top: 50px;
          font-size: 36px;
          font-weight: 600;
          color: #1F65FE;
        }

        .box-name2 {
          margin-top: 19px;
          font-size: 20px;
          font-weight: 600;
          color: #1F65FE;
        }

        .box-text {
          margin-left: 12px;
          padding-left: 23px;
          border-left: 3px solid #D6D6D6;;
          margin-top: 32px;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          color: #383838;
        }

        .right-item {
          display: flex;
          color: #1F65FE;
          font-weight: 600;
          font-size: 16px;
          margin-left: 12px;
          margin-bottom: 25px;

          .right-item-text {
            margin-top: 13px;
            font-size: 12px;
            color: #767676;
          }
        }
      }

      .pad-params {
        margin-top: 28px;
        font-size: 20px;
        font-weight: 600;
        color: #151515;

        .params-grid {
          display: grid;
          grid-template-columns: 1fr 1fr ;
          column-gap: 10px;
          row-gap: 10px;
          color: #151515;

          .grid-item {
            margin-top: 59px;
            font-size: 24px;
            font-weight: 600;

            .item-text {
              margin-top: 24px;
              display: flex;
              font-size: 16px;
              line-height: 32px;

            }
          }
        }
      }

      .box-mesh-name {
        margin-bottom: 32px;
        font-size: 36px;
        font-weight: 600;
        color: #1F65FE;
      }

      .box-mesh-text {
        border-left: 3px solid #D6D6D6;
        padding-left: 23px;
        margin-left: 31px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #383838;
        margin-bottom: 129px;
      }

      .mesh-item {
        display: flex;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/dmsb/index.vue